enum TimeSelectionType {
    CONST,
    CUSTOM,
    LIVE,
}

export default TimeSelectionType;
